import React from 'react';


export const Loader = () => {
    return (
        <div className='loader-container'>
            <div className='spinner'></div>
            <p>Loading..</p>
        </div>
    )
};
